import React, {useEffect, useRef} from 'react';
import {basicSetup} from 'codemirror';
import {EditorState} from '@codemirror/state';
import {EditorView} from '@codemirror/view';
import {html} from '@codemirror/lang-html';
import {markdown} from '@codemirror/lang-markdown';

export default function SourceEditor({value, mode, onChange, label}) {
    const parentRef = useRef(null);
    const viewRef = useRef(null);
    const onChangeRef = useRef(onChange);

    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);

    useEffect(() => {
        const view = new EditorView({
            parent: parentRef.current,
            state: EditorState.create({
                doc: value || '',
                extensions: [
                    basicSetup,
                    mode === 'html' ? html() : markdown(),
                    EditorView.lineWrapping,
                    EditorView.contentAttributes.of({
                        'aria-label': label || `${mode === 'html' ? 'HTML' : 'Markdown'} source`,
                    }),
                    EditorView.updateListener.of(update => {
                        if (update.docChanged) {
                            onChangeRef.current?.(update.state.doc.toString());
                        }
                    }),
                ],
            }),
        });
        viewRef.current = view;
        return () => {
            view.destroy();
            viewRef.current = null;
        };
    }, [mode, label]);

    useEffect(() => {
        const view = viewRef.current;
        if (!view || view.state.doc.toString() === (value || '')) {
            return;
        }
        view.dispatch({
            changes: {from: 0, to: view.state.doc.length, insert: value || ''},
        });
    }, [value]);

    return <div className="content-source-editor" ref={parentRef} />;
}
